<template>
    
    <form method="POST"
          @submit.prevent="validarFormulario()"
          data-vv-scope="adjunto"
          enctype="multipart/form-data"
          class="padding-content"
    >
    
    <div class="padding-content shadow-sm bg-gray-50">

        <div>
            <strong>Agregar adjunto</strong>
        </div>
        <br />

        <b-row>
            <b-col>
                <!-- Idioma -->
                <b-form-group label="Idioma:">
                    <el-select id="idioma"
                               name="idioma"
                               v-model="adjunto.idioma"
                               filterable
                               no-data-text="No hay datos que coincidan"
                               no-match-text="No hay datos que coincidan"
                               data-vv-as=" "
                               v-validate="'required'"
                               @focus="listarIdiomas"
                    >
                        <el-option v-for="idioma in idiomas"
                                   :key="idioma.id"
                                   :label="idioma.lista"
                                   :value="idioma.id"
                        />
                    </el-select>
                    <span class="text-danger span-error small">{{ errors.first('adjunto.idioma') }}</span>
                </b-form-group>
            </b-col>

            <b-col>
                <!-- Tipo -->
                <b-form-group
                    label="Tipo:"
                >
                    <el-select id="tipo"
                               name="tipo"
                               v-model="adjunto.tipo"
                               filterable
                               no-data-text="No hay datos que coincidan"
                               no-match-text="No hay datos que coincidan"
                               data-vv-as=" "
                               v-validate="'required'"
                               @focus="listarTipos"
                    >
                        <el-option v-for="tipo in getAvailableTypes"
                                   :key="tipo.id"
                                   :label="tipo.lista"
                                   :value="tipo.id"
                        />
                    </el-select>
                    <span class="text-danger span-error small">{{ errors.first('adjunto.tipo') }}</span>
                </b-form-group>
            </b-col>

            <b-col>
                <!-- Fecha -->
                <b-form-group>
                    <label for="fecha"
                           class="w-100"
                    >
                        Fecha:
                        <span class="float-right"
                              v-if="cumpleDecreto"
                        >
                            No cumple
                            <b-form-checkbox v-model="adjunto.no_cumple"
                                             :value="1"
                                             :unchecked-value="0"
                                             @change="setNoCumple"
                                             class="ml-2 float-right"
                            />
                        </span>
                    </label>
                    <el-date-picker id="fecha"
                                    name="fecha"
                                    v-model="adjunto.fecha"
                                    class="w-100"
                                    type="date"
                                    data-vv-as=" "
                                    value-format="yyyy-MM-dd"
                                    format="dd/MM/yyyy"
                                    v-validate="'date_format:yyyy-MM-dd'"
                    />
                    <b-badge
                        :variant="adjunto.estado_fds === 162 ? 'success' : 'danger'"
                        v-if="cumpleDecreto !== null"
                        key="cumple"
                        class="float-right font-weight-light"
                    >
                        {{ estados_fds.find(s => s.id === adjunto.estado_fds) ? estados_fds.find(s => s.id === adjunto.estado_fds).lista : '' }}
                    </b-badge>

                    <span class="text-danger span-error small">{{ errors.first('adjunto.fecha') }}</span>
                </b-form-group>
            </b-col>

            <b-col v-if="adjunto.no_cumple">
                <b-form-group label="Observación no cumplimiento">
                    <el-input id="observacion_no_cumple"
                              name="observacion_no_cumple"
                              v-model="adjunto.observacion_no_cumple"
                              v-validate="{rules:{required: adjunto.no_cumple}}"
                              data-vv-as=" "
                              size="sm"
                    />
                    <span class="text-danger span-error small">
                        {{ errors.first('formulario-adjuntos.observacion_no_cumple') }}
                    </span>
                </b-form-group>
            </b-col>
        </b-row>

        <!-- Adjunto -->
        <b-form-group label="Adjunto:">
            <b-form-file id="avatar"
                         name="avatar"
                         v-model="adjunto.avatar"
                         data-vv-as=" "
                         :data-vv-delay="1000"
                         v-validate="'required|mimes:*/*'"
                         placeholder="Elija un archivo o suéltelo aquí..."
                         drop-placeholder="Suelte el archivo aquí ..."
            />
            <span class="text-danger span-error small">{{ errors.first('adjunto.avatar') }}</span>
        </b-form-group>

        <!-- Observación -->
        <b-form-group horizontal
                      breakpoint="md"
                      label="Observación:"
                      label-for="inputHorizontal"
        >
            <b-form-textarea v-model="adjunto.observacion"
                             placeholder="Observación del adjunto"
                             :rows="3"
                             :max-rows="6"
            />
        </b-form-group>

        <br />
    </div>

    <br />
    <b-row>
        <b-col>
            <button class="btn btn-secondary float-left"
                    @click="setModalPaso(1)"
            >
                Anterior
            </button>
            <button class="btn btn-primary float-right"
                    @click="validarFormulario()"
            >
                Siguiente
            </button>
            <button class="btn btn-secondary float-right mr-2"
                    @click="setModalVer(false)"
            >
                Cancelar
            </button>
        </b-col>
    </b-row>

    </form>
</template>

<script>

import Vue from 'vue';

import VeeValidate, {Validator} from 'vee-validate';
import es from 'vee-validate/dist/locale/es';

Vue.use(VeeValidate, {
    fieldsBagName: 'vvFields',
    events: 'change'
});

Validator.localize('es', es);
import {mapState, mapActions, mapMutations} from 'vuex';

export default {
    name: 'adjunto',
    async mounted() {
        await this.listarEstadoFds();
    },
    computed: {
        ...mapState('pasoapaso', [
            'adjunto',
            'idiomas',
            'tipos',
            'estados_fds'
        ]),
        /**
         * Cargar solo los tipos validos de adjuntos (FDS o MSDS)
         * @author Fernando Claros
         */
        getAvailableTypes() {
            return this.tipos.filter(x => x.id === 154 || x.id === 155);
        },
        cumpleDecreto() {
            this.adjunto.no_cumple = 0;

            if (this.adjunto.tipo === 155) {
                // Si es MSDS, automáticamente no cumple
                this.adjunto.estado_fds = 163;
                return false;
            } else if (this.adjunto.tipo === 154) {
                // Validar si es FDS

                if (this.adjunto.idioma !== 137) {
                    this.adjunto.estado_fds = 163;
                    return false;
                }

                if (this.adjunto.fecha) {
                    // Validar si la fecha no está vacía
                    const dd = new Date();
                    const m = dd.getMonth() + 1;
                    const d = dd.getDate();
                    const y = dd.getFullYear();

                    const start = new Date(this.adjunto.fecha);
                    start.setFullYear(start.getFullYear() + 5);

                    const startf = start.toISOString().slice(0, 10).replace(/-/g, '-');

                    //Si la fecha final es menor que la fecha actual entonces el fds no cumple
                    if (Date.parse(startf) < Date.parse(y + '-' + m + '-' + d)) {
                        //No cumple decreto
                        this.adjunto.estado_fds = 163;
                        return false;
                    } else {
                        //Cumple decreto
                        this.adjunto.estado_fds = 162;
                        return true;
                    }
                } else {
                    this.adjunto.estado_fds = 163;
                    return false;
                }
            } else {
                this.adjunto.estado_fds = 163;
                return null;
            }
        },
    },
    methods: {
        ...mapActions('pasoapaso', [
            'listarIdiomas',
            'listarTipos',
            'listarEstadoFds'
        ]),
        ...mapMutations('pasoapaso', ['setModalPaso', 'setModalVer']),
        setNoCumple(no_cumple) {
            if (!!no_cumple) {
                this.adjunto.estado_fds = 163;
            } else {
                this.adjunto.estado_fds = 162;
            }
        },
        validarFormulario() {
            this.$validator.validateAll('adjunto').then(result => {
                if (result) {
                    this.setModalPaso(3);
                }
            });
        }
    }
};
</script>

<style>
.padding-content{
    padding: 20px;
}
.custom-file-label::after {
    content: 'Buscar' !important;
}
</style>
